// components/ActionButtons.jsx
import { Pencil } from "lucide-react";
import { Link } from "react-router-dom";

function ActionButtons({ editUrl, onDelete }) {
  return (
    <div className="flex justify-center gap-2">
      <Link
        to={editUrl}
        aria-label="Editar"
        className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-yellow-400 p-2 text-white shadow transition-all duration-300 hover:bg-yellow-500"
        title="Editar"
      >
        <Pencil size={16} />
      </Link>
      {/* <button
        onClick={onDelete}
        className="inline-flex items-center bg-red-500 hover:bg-red-600 text-white p-2 rounded-lg shadow transition-all duration-300"
        title="Eliminar"
      >
        <Trash2 size={16} />
      </button> */}
    </div>
  );
}

export default ActionButtons;
